export type SignInMode = 'AUTO' | 'MANUAL' | 'ON_ERROR';
